<template>
  <div></div>
</template>

<script>
  export default {
    created() {
      this.$router.replace(this.$route.query.redirect);
    },
  };
</script>


<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/reflushPage/index.vue